// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5742 ? "9cb54ea0" : chunkId) + "." + {"869":"5eb0bf4345b89e2d","3031":"befccacc52827523","5742":"a03f72bad274ca8d","5928":"b24974a454ee82ff"}[chunkId] + ".js";
};